import { render } from "./ignorePage.vue?vue&type=template&id=4b91dfb0"
import script from "./ignorePage.vue?vue&type=script&lang=js"
export * from "./ignorePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__